import { useLazyQuery, useMutation } from '@apollo/client';
import { format } from 'date-fns';
import { customAlphabet } from 'nanoid';
import { useState } from 'react';
import {
    UPDATE_STUDENT_APRIL_FEE_STATUS,
    UPDATE_STUDENT_AUGUST_FEE_STATUS,
    UPDATE_STUDENT_DECEMBER_FEE_STATUS,
    UPDATE_STUDENT_FEBRUARY_FEE_STATUS,
    UPDATE_STUDENT_JANUARY_FEE_STATUS,
    UPDATE_STUDENT_JULY_FEE_STATUS,
    UPDATE_STUDENT_JUNE_FEE_STATUS,
    UPDATE_STUDENT_MARCH_FEE_STATUS,
    UPDATE_STUDENT_MAY_FEE_STATUS,
    UPDATE_STUDENT_NOVEMBER_FEE_STATUS,
    UPDATE_STUDENT_OCTOBER_FEE_STATUS,
    UPDATE_STUDENT_SEPTEMBER_FEE_STATUS
} from 'services/managment/mutation';
import {
    GET_CLASS_FEE_APR,
    GET_CLASS_FEE_AUG,
    GET_CLASS_FEE_DEC,
    GET_CLASS_FEE_FEB,
    GET_CLASS_FEE_JAN,
    GET_CLASS_FEE_JUL,
    GET_CLASS_FEE_JUN,
    GET_CLASS_FEE_MAR,
    GET_CLASS_FEE_MAY,
    GET_CLASS_FEE_NOV,
    GET_CLASS_FEE_OCT,
    GET_CLASS_FEE_SEP
} from 'services/managment/query';

function useClassFee() {
    const [updateAprilFeeStatus] = useMutation(UPDATE_STUDENT_APRIL_FEE_STATUS);
    const [updateMayFeeStatus] = useMutation(UPDATE_STUDENT_MAY_FEE_STATUS);
    const [updateJuneFeeStatus] = useMutation(UPDATE_STUDENT_JUNE_FEE_STATUS);
    const [updateJulyFeeStatus] = useMutation(UPDATE_STUDENT_JULY_FEE_STATUS);
    const [updateAugustFeeStatus] = useMutation(UPDATE_STUDENT_AUGUST_FEE_STATUS);
    const [updateSeptemberFeeStatus] = useMutation(UPDATE_STUDENT_SEPTEMBER_FEE_STATUS);
    const [updateOctoberFeeStatus] = useMutation(UPDATE_STUDENT_OCTOBER_FEE_STATUS);
    const [updateNovemberFeeStatus] = useMutation(UPDATE_STUDENT_NOVEMBER_FEE_STATUS);
    const [updateDecemberFeeStatus] = useMutation(UPDATE_STUDENT_DECEMBER_FEE_STATUS);
    const [updateJanuaryFeeStatus] = useMutation(UPDATE_STUDENT_JANUARY_FEE_STATUS);
    const [updateFebruaryFeeStatus] = useMutation(UPDATE_STUDENT_FEBRUARY_FEE_STATUS);
    const [updateMarchFeeStatus] = useMutation(UPDATE_STUDENT_MARCH_FEE_STATUS);

    const [getAprFeeDetails] = useLazyQuery(GET_CLASS_FEE_APR);
    const [getMayFeeDetails] = useLazyQuery(GET_CLASS_FEE_MAY);
    const [getJunFeeDetails] = useLazyQuery(GET_CLASS_FEE_JUN);
    const [getJulFeeDetails] = useLazyQuery(GET_CLASS_FEE_JUL);
    const [getAugFeeDetails] = useLazyQuery(GET_CLASS_FEE_AUG);
    const [getSepFeeDetails] = useLazyQuery(GET_CLASS_FEE_SEP);
    const [getOctFeeDetails] = useLazyQuery(GET_CLASS_FEE_OCT);
    const [getNovFeeDetails] = useLazyQuery(GET_CLASS_FEE_NOV);
    const [getDecFeeDetails] = useLazyQuery(GET_CLASS_FEE_DEC);
    const [getJanFeeDetails] = useLazyQuery(GET_CLASS_FEE_JAN);
    const [getFebFeeDetails] = useLazyQuery(GET_CLASS_FEE_FEB);
    const [getMarFeeDetails] = useLazyQuery(GET_CLASS_FEE_MAR);

    const [responseData, setResponseData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isFeeUpdated, setIsFeeUpdated] = useState(false);

    const getFeeDeatails = async (monthName, studentId) => {
        if (monthName === 'Apr') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getAprFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.apr,
                        mode: response.data?.class_fees_by_pk?.aprmode,
                        transactionNo: response.data?.class_fees_by_pk?.aprtxn,
                        date: response.data?.class_fees_by_pk?.aprdt,
                        updatedBy: response.data?.class_fees_by_pk?.aprudb,
                        invoiceNo: response.data?.class_fees_by_pk?.aprinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'May') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getMayFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.may,
                        mode: response.data?.class_fees_by_pk?.maymode,
                        transactionNo: response.data?.class_fees_by_pk?.maytxn,
                        date: response.data?.class_fees_by_pk?.maydt,
                        updatedBy: response.data?.class_fees_by_pk?.mayudb,
                        invoiceNo: response.data?.class_fees_by_pk?.mayinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Jun') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getJunFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.jun,
                        mode: response.data?.class_fees_by_pk?.junmode,
                        transactionNo: response.data?.class_fees_by_pk?.juntxn,
                        date: response.data?.class_fees_by_pk?.jundt,
                        updatedBy: response.data?.class_fees_by_pk?.junudb,
                        invoiceNo: response.data?.class_fees_by_pk?.juninv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Jul') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getJulFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.jul,
                        mode: response.data?.class_fees_by_pk?.julmode,
                        transactionNo: response.data?.class_fees_by_pk?.jultxn,
                        date: response.data?.class_fees_by_pk?.juldt,
                        updatedBy: response.data?.class_fees_by_pk?.juludb,
                        invoiceNo: response.data?.class_fees_by_pk?.julinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Aug') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getAugFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.aug,
                        mode: response.data?.class_fees_by_pk?.augmode,
                        transactionNo: response.data?.class_fees_by_pk?.augtxn,
                        date: response.data?.class_fees_by_pk?.augdt,
                        updatedBy: response.data?.class_fees_by_pk?.augudb,
                        invoiceNo: response.data?.class_fees_by_pk?.auginv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Sep') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getSepFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.sep,
                        mode: response.data?.class_fees_by_pk?.sepmode,
                        transactionNo: response.data?.class_fees_by_pk?.septxn,
                        date: response.data?.class_fees_by_pk?.sepdt,
                        updatedBy: response.data?.class_fees_by_pk?.sepudb,
                        invoiceNo: response.data?.class_fees_by_pk?.sepinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Oct') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getOctFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.oct,
                        mode: response.data?.class_fees_by_pk?.octmode,
                        transactionNo: response.data?.class_fees_by_pk?.octtxn,
                        date: response.data?.class_fees_by_pk?.octdt,
                        updatedBy: response.data?.class_fees_by_pk?.octudb,
                        invoiceNo: response.data?.class_fees_by_pk?.octinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Nov') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getNovFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.nov,
                        mode: response.data?.class_fees_by_pk?.novmode,
                        transactionNo: response.data?.class_fees_by_pk?.novtxn,
                        date: response.data?.class_fees_by_pk?.novdt,
                        updatedBy: response.data?.class_fees_by_pk?.novudb,
                        invoiceNo: response.data?.class_fees_by_pk?.novinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Dec') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getDecFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.dec,
                        mode: response.data?.class_fees_by_pk?.decmode,
                        transactionNo: response.data?.class_fees_by_pk?.dectxn,
                        date: response.data?.class_fees_by_pk?.decdt,
                        updatedBy: response.data?.class_fees_by_pk?.decudb,
                        invoiceNo: response.data?.class_fees_by_pk?.decinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Jan') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getJanFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.jan,
                        mode: response.data?.class_fees_by_pk?.janmode,
                        transactionNo: response.data?.class_fees_by_pk?.jantxn,
                        date: response.data?.class_fees_by_pk?.jandt,
                        updatedBy: response.data?.class_fees_by_pk?.janudb,
                        invoiceNo: response.data?.class_fees_by_pk?.janinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Feb') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getFebFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.feb,
                        mode: response.data?.class_fees_by_pk?.febmode,
                        transactionNo: response.data?.class_fees_by_pk?.febtxn,
                        date: response.data?.class_fees_by_pk?.febdt,
                        updatedBy: response.data?.class_fees_by_pk?.febudb,
                        invoiceNo: response.data?.class_fees_by_pk?.febinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
        if (monthName === 'Mar') {
            setIsLoading(true);
            setIsFeeUpdated(false);
            getMarFeeDetails({
                variables: {
                    studentId
                },
                refetch: true,
                fetchPolicy: 'cache-and-network'
            })
                .then((response) => {
                    setResponseData({
                        amount: response.data?.class_fees_by_pk?.mar,
                        mode: response.data?.class_fees_by_pk?.marmode,
                        transactionNo: response.data?.class_fees_by_pk?.martxn,
                        date: response.data?.class_fees_by_pk?.mardt,
                        updatedBy: response.data?.class_fees_by_pk?.marudb,
                        invoiceNo: response.data?.class_fees_by_pk?.marinv
                    });
                    setIsLoading(false);
                })
                .catch((error) => {});
        }
    };

    const updateFeeDetails = async (monthName, studentId, className, rollNo, updatedBy, values, handleFeeUpdate) => {
        const invoiceNo = customAlphabet('1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ', 9);
        if (monthName === 'Apr') {
            updateAprilFeeStatus({
                variables: {
                    studentId,
                    apr: values.amount,
                    aprmode: values.mode,
                    aprtxn: values.transactionNo,
                    aprdt: format(new Date(values.date), 'yyyy-MM-dd'),
                    aprudb: updatedBy,
                    aprinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 3,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.aprinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'May') {
            updateMayFeeStatus({
                variables: {
                    studentId,
                    may: values.amount,
                    maymode: values.mode,
                    maytxn: values.transactionNo,
                    maydt: format(new Date(values.date), 'yyyy-MM-dd'),
                    mayudb: updatedBy,
                    mayinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 4,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.mayinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Jun') {
            updateJuneFeeStatus({
                variables: {
                    studentId,
                    jun: values.amount,
                    junmode: values.mode,
                    juntxn: values.transactionNo,
                    jundt: format(new Date(values.date), 'yyyy-MM-dd'),
                    junudb: updatedBy,
                    juninv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 5,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.juninv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Jul') {
            updateJulyFeeStatus({
                variables: {
                    studentId,
                    jul: values.amount,
                    julmode: values.mode,
                    jultxn: values.transactionNo,
                    juldt: format(new Date(values.date), 'yyyy-MM-dd'),
                    juludb: updatedBy,
                    julinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 6,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.julinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Aug') {
            updateAugustFeeStatus({
                variables: {
                    studentId,
                    aug: values.amount,
                    augmode: values.mode,
                    augtxn: values.transactionNo,
                    augdt: format(new Date(values.date), 'yyyy-MM-dd'),
                    augudb: updatedBy,
                    auginv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 7,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.auginv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Sep') {
            updateSeptemberFeeStatus({
                variables: {
                    studentId,
                    sep: values.amount,
                    sepmode: values.mode,
                    septxn: values.transactionNo,
                    sepdt: format(new Date(values.date), 'yyyy-MM-dd'),
                    sepudb: updatedBy,
                    sepinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 8,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.sepinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Oct') {
            updateOctoberFeeStatus({
                variables: {
                    studentId,
                    oct: values.amount,
                    octmode: values.mode,
                    octtxn: values.transactionNo,
                    octdt: format(new Date(values.date), 'yyyy-MM-dd'),
                    octudb: updatedBy,
                    octinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 9,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.octinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Nov') {
            updateNovemberFeeStatus({
                variables: {
                    studentId,
                    nov: values.amount,
                    novmode: values.mode,
                    novtxn: values.transactionNo,
                    novdt: format(new Date(values.date), 'yyyy-MM-dd'),
                    novudb: updatedBy,
                    novinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 10,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.novinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Dec') {
            updateDecemberFeeStatus({
                variables: {
                    studentId,
                    dec: values.amount,
                    decmode: values.mode,
                    dectxn: values.transactionNo,
                    decdt: format(new Date(values.date), 'yyyy-MM-dd'),
                    decudb: updatedBy,
                    decinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 11,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.decinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Jan') {
            updateJanuaryFeeStatus({
                variables: {
                    studentId,
                    jan: values.amount,
                    janmode: values.mode,
                    jantxn: values.transactionNo,
                    jandt: format(new Date(values.date), 'yyyy-MM-dd'),
                    janudb: updatedBy,
                    janinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 0,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.janinv
                    });
                    setIsFeeUpdated(true);
                },
                onError: (error) => {}
            });
        }
        if (monthName === 'Feb') {
            updateFebruaryFeeStatus({
                variables: {
                    studentId,
                    feb: values.amount,
                    febmode: values.mode,
                    febtxn: values.transactionNo,
                    febdt: format(new Date(values.date), 'yyyy-MM-dd'),
                    febudb: updatedBy,
                    febinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 1,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.febinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
        if (monthName === 'Mar') {
            updateMarchFeeStatus({
                variables: {
                    studentId,
                    mar: values.amount,
                    marmode: values.mode,
                    martxn: values.transactionNo,
                    mardt: format(new Date(values.date), 'yyyy-MM-dd'),
                    marudb: updatedBy,
                    marinv: `TUT${invoiceNo()}`
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: values.amount,
                        monthNo: 2,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: values.amount,
                        mode: values.mode,
                        transactionNo: values.transactionNo,
                        date: format(new Date(values.date), 'yyyy-MM-dd'),
                        updatedBy,
                        invoiceNo: data?.update_class_fees_by_pk?.marinv
                    });
                    setIsFeeUpdated(true);
                }
            });
        }
    };

    const handleDueFees = async (monthName, studentId, handleFeeUpdate) => {
        if (monthName === 'Apr') {
            updateAprilFeeStatus({
                variables: {
                    studentId,
                    apr: null,
                    aprmode: null,
                    aprtxn: null,
                    aprdt: null,
                    aprudb: null,
                    aprinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 3,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'May') {
            updateMayFeeStatus({
                variables: {
                    studentId,
                    may: null,
                    maymode: null,
                    maytxn: null,
                    maydt: null,
                    mayudb: null,
                    mayinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 4,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Jun') {
            updateJuneFeeStatus({
                variables: {
                    studentId,
                    jun: null,
                    junmode: null,
                    juntxn: null,
                    jundt: null,
                    junudb: null,
                    juninv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 5,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Jul') {
            await updateJulyFeeStatus({
                variables: {
                    studentId,
                    jul: null,
                    julmode: null,
                    jultxn: null,
                    juldt: null,
                    juludb: null,
                    julinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 6,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Aug') {
            await updateAugustFeeStatus({
                variables: {
                    studentId,
                    aug: null,
                    augmode: null,
                    augtxn: null,
                    augdt: null,
                    augudb: null,
                    auginv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 7,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Sep') {
            await updateSeptemberFeeStatus({
                variables: {
                    studentId,
                    sep: null,
                    sepmode: null,
                    septxn: null,
                    sepdt: null,
                    sepudb: null,
                    sepinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 8,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Oct') {
            await updateOctoberFeeStatus({
                variables: {
                    studentId,
                    oct: null,
                    octmode: null,
                    octtxn: null,
                    octdt: null,
                    octudb: null,
                    octinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 9,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Nov') {
            await updateNovemberFeeStatus({
                variables: {
                    studentId,
                    nov: null,
                    novmode: null,
                    novtxn: null,
                    novdt: null,
                    novudb: null,
                    novinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 10,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Dec') {
            await updateDecemberFeeStatus({
                variables: {
                    studentId,
                    dec: null,
                    decmode: null,
                    dectxn: null,
                    decdt: null,
                    decudb: null,
                    decinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 11,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Jan') {
            await updateJanuaryFeeStatus({
                variables: {
                    studentId,
                    jan: null,
                    janmode: null,
                    jantxn: null,
                    jandt: null,
                    janudb: null,
                    janinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 0,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Feb') {
            await updateFebruaryFeeStatus({
                variables: {
                    studentId,
                    feb: null,
                    febmode: null,
                    febtxn: null,
                    febdt: null,
                    febudb: null,
                    febinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 1,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
        if (monthName === 'Mar') {
            await updateMarchFeeStatus({
                variables: {
                    studentId,
                    mar: null,
                    marmode: null,
                    martxn: null,
                    mardt: null,
                    marudb: null,
                    marinv: null
                },
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'no-cache',
                onCompleted: (data) => {
                    handleFeeUpdate({
                        type: 0,
                        amount: null,
                        monthNo: 2,
                        studentId: data?.update_class_fees_by_pk?.student_id
                    });
                    setResponseData({
                        amount: null,
                        mode: null,
                        transactionNo: null,
                        date: null,
                        updatedBy: null,
                        invoiceNo: null
                    });
                }
            });
        }
    };

    return [getFeeDeatails, updateFeeDetails, handleDueFees, responseData, isLoading, isFeeUpdated];
}

export default useClassFee;
